import React from 'react';
import {
  Container,
  DetailHeaderSlot,
  DetailBody,
  DetailMain,
  DetailAside
} from '../../PurchaseOrderDetail.styles';
import {
  Skel,
  PageSkeleton,
  PageSkeletonShell,
  CrumbSkeletonStrip,
  ParamsSkeletonBox,
  ParamSkeleton,
  ProductsSkeletonPanel,
  ProductsToolbarSkeleton,
  ProductsToolbarRight,
  SearchSkel,
  TableSkeletonShell,
  TableHeadSkeleton,
  ProductRowSkeleton,
  ProductInfoSkeleton,
  ProductLinesSkeleton,
  TotalsSkeletonBox,
  TotalsRowSkeleton,
  AsideSkeletonBox,
  AsideTabsSkeleton,
  AsideBodySkeleton,
  TimelineItemSkeleton,
  TimelineLinesSkeleton
} from './DetailSkeleton.styles';

const HEADER_VALUE_SHAPES = [
  { height: '16px', width: '70%' },
  { height: '22px', width: '88px', radius: '11px' },
  { height: '22px', width: '72%', radius: '11px' },
  { height: '22px', width: '64%', radius: '11px' },
  { height: '16px', width: '78%' },
  { height: '16px', width: '85%' },
  { height: '16px', width: '90%' },
  { height: '16px', width: '82%' }
];

export function HeaderSkeleton() {
  return (
    <ParamsSkeletonBox role="status" aria-busy="true" aria-label="Loading">
      {HEADER_VALUE_SHAPES.map((shape, index) => (
        <ParamSkeleton key={index}>
          <Skel $height="10px" $width="46%" $delay={`${index * 0.05}s`} />
          <Skel
           
            $height={shape.height}
            $width={shape.width}
            $radius={shape.radius}
          />
        </ParamSkeleton>
      ))}
    </ParamsSkeletonBox>
  );
}

export function ProductsSkeleton() {
  return (
    <ProductsSkeletonPanel>
      <ProductsToolbarSkeleton>
        <Skel $height="12px" $width="120px" />
        <ProductsToolbarRight>
          <SearchSkel />
          <Skel $height="36px" $width="36px" $radius="50%" />
          <Skel $height="36px" $width="36px" $radius="50%" />
        </ProductsToolbarRight>
      </ProductsToolbarSkeleton>
      <TableSkeletonShell>
        <TableHeadSkeleton>
          <Skel $height="10px" $width="40%" />
          <Skel $height="10px" $width="55%" />
          <Skel $height="10px" $width="70%" />
          <Skel $height="10px" $width="50%" />
        </TableHeadSkeleton>
        {Array.from({ length: 5 }).map((_, index) => (
          <ProductRowSkeleton key={index}>
            <ProductInfoSkeleton>
              <Skel $height="48px" $width="48px" $radius="7px" $delay={`${index * 0.08}s`} />
              <ProductLinesSkeleton>
                <Skel $height="14px" $width="78%" />
                <Skel $height="10px" $width="52%" />
              </ProductLinesSkeleton>
            </ProductInfoSkeleton>
            <Skel $height="12px" $width="70%" />
            <Skel $height="12px" $width="55%" />
            <Skel $height="14px" $width="65%" />
          </ProductRowSkeleton>
        ))}
      </TableSkeletonShell>
      <TotalsSkeletonBox>
        <TotalsRowSkeleton>
          <Skel $height="11px" $width="90px" />
          <Skel $height="14px" $width="110px" />
        </TotalsRowSkeleton>
        <TotalsRowSkeleton $total>
          <Skel $height="16px" $width="70px" />
          <Skel $height="22px" $width="140px" />
        </TotalsRowSkeleton>
      </TotalsSkeletonBox>
    </ProductsSkeletonPanel>
  );
}

export function AsideSkeleton() {
  return (
    <AsideSkeletonBox>
      <AsideTabsSkeleton>
        <Skel $height="12px" $width="96px" />
        <Skel $height="12px" $width="72px" />
      </AsideTabsSkeleton>
      <AsideBodySkeleton>
        {Array.from({ length: 3 }).map((_, index) => (
          <TimelineItemSkeleton key={index}>
            <Skel $height="28px" $width="28px" $radius="50%" $delay={`${index * 0.1}s`} />
            <TimelineLinesSkeleton>
              <Skel $height="15px" $width="42%" />
              <Skel $height="12px" $width="78%" />
              <Skel $height="12px" $width="88%" />
              <Skel $height="11px" $width="48%" />
            </TimelineLinesSkeleton>
          </TimelineItemSkeleton>
        ))}
      </AsideBodySkeleton>
    </AsideSkeletonBox>
  );
}

export default function PurchaseOrderDetailSkeleton() {
  return (
    <PageSkeleton role="status" aria-busy="true" aria-label="Loading">
      <DetailHeaderSlot>
        <HeaderSkeleton />
      </DetailHeaderSlot>
      <DetailBody>
        <DetailMain>
          <ProductsSkeleton />
        </DetailMain>
        <DetailAside>
          <AsideSkeleton />
        </DetailAside>
      </DetailBody>
    </PageSkeleton>
  );
}

export function BreadcrumbSkeleton() {
  return (
    <CrumbSkeletonStrip>
      <Skel $height="12px" $width="90px" />
      <Skel $height="12px" $width="110px" />
      <Skel $height="12px" $width="70px" />
    </CrumbSkeletonStrip>
  );
}

export function PurchaseOrderDetailPageSkeleton() {
  return (
    <PageSkeletonShell role="status" aria-busy="true" aria-label="Loading">
      <BreadcrumbSkeleton />
      <Container>
        <PurchaseOrderDetailSkeleton />
      </Container>
    </PageSkeletonShell>
  );
}
